import {
  EMPTY_PRODUCT_BREAKDOWN,
  ENTRY_POINT_LABELS
} from "../constants";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "./formatters";

export function formatAhaLag(purchase) {
  const samples = Number(purchase?.ahaLag?.samples || 0);
  if (samples <= 0) return "— / —";
  return `${formatNumber(purchase?.ahaLag?.avgDays)} / ${formatNumber(purchase?.ahaLag?.medianDays)}`;
}

export function formatAhaLagBuckets(purchase) {
  const samples = Number(purchase?.ahaLag?.samples || 0);
  if (samples <= 0) return "— / — / — / —";
  return `${formatPercent(purchase?.ahaLag?.day0)} / ${formatPercent(
    purchase?.ahaLag?.day1
  )} / ${formatPercent(purchase?.ahaLag?.day3)} / ${formatPercent(purchase?.ahaLag?.day7)}`;
}

export function formatProductCell(period, key) {
  const row = period?.byProduct?.[key] || EMPTY_PRODUCT_BREAKDOWN[key] || { count: 0, revenue: 0 };
  return `${formatNumber(row.count)} (${formatMoney(row.revenue)})`;
}

export function formatEntryPoint(value) {
  const key = value ? String(value) : "unknown";
  return ENTRY_POINT_LABELS[key] || key;
}
